import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zaypqnicjuzfipoosdwn.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpheXBxbmljanV6Zmlwb29zZHduIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU2NTY3OTIsImV4cCI6MjA5MTIzMjc5Mn0.Rnvgjj6AWob1LI0tB1tUMIPXfFGt5xcDAfRToKluBHw';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: window.localStorage,
    },
});